<template>
  <div class="m-card">
    <div class="m-card-header">
      <div class="m-header-word">{{title}}</div>
      <div class="m-header-button" @click="toggleShow">更多</div>
    </div>
    <div :class="contentClass">
      <div v-for="(item, index) in contentArr" class="m-card-content-item" :key="index" :href="`/#${item.businessUrl}`" @click="jumpTo(item)">{{item.title}}</div>
    </div>
  </div>
</template>
<script>
import message from '../../services/message';
import utils from '../../libs/utils.js';

export default {
  name: 'MessageCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    contentArr: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      contentVisible: false,
    };
  },
  computed: {
    contentClass() {
      return [
        'm-card-content',
        {
          'm-card-content-hidden': !this.contentVisible,
        },
      ];
    },
  },
  methods: {
    toggleShow() {
      this.contentVisible = !this.contentVisible;
    },
    jumpTo(item) {
      let path = decodeURIComponent(item.businessUrl);
      path[0] === '/' || (path = `/${path}`);
      path = utils.handleMessagePathChange(path, '/baseInfo/patient/patientEdit/', '/baseInfo/patient/patientBase/patientEdit/');
      path = utils.handleMessagePathChange(path, '/baseInfo/patient/patientCheck/', '/baseInfo/patient/patientBase/patientCheck/');
      if (item.messageType === 1 || item.businessType === 'patient_rebuy_un_rebuy') {
        console.log(item.businessUrl);

        message.messageDeal({ messageId: item.id }).then(() => {
          this.$router.push({ path });
        });
      } else {
        this.$router.push({ path });
      }
      this.$emit('CardChange');
    },
  },
};
</script>
<style lang="less" scoped>
.m-card{
  background: #FFFFFF;
  border: 1px solid #DEDEDE;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  .m-card-header{
    line-height: 22px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .m-header-word{
      color: rgba(0,0,0,0.87);
    }
    .m-header-button{
      color: rgba(0,0,0,0.54);
      cursor: pointer;
    }
  }
  .m-card-content{
    .m-card-content-item{
      display: block;
      font-size: 14px;
      color: rgba(0,0,0,0.65);
      line-height: 22px;
      margin-bottom: 5px;
    }
    .m-card-content-item:hover{
      cursor: pointer;
    }
  }
  .m-card-content-hidden{
    height: 120px;
    overflow: hidden;
  }
}
</style>
